const OilcoReports = {
  FleetAccount: "fleet-account",
  VoucherClaim: "voucher-claim",
  SupplierWPP: "supplier-wpp",
  Settlements: "settlements",
  FleetPrices: "fleet-prices",
  PricingChanges: "pricing-changes",
  LubeservOnSite: "lubeserv-on-site",
  LubeservOnWheels: "lubeserv-on-wheels",
  VoucherCampaign: "voucher-campaign",
  StationNegotiatedDiscount: "station-negotiated-discount",
};

const ReportType = {
  CashIn: "cashin",
  BuyFuel: "buy-fuel",
  Redemption: "redemption",
  FleetAccount: "fleet-account",
  FleetPrices: "fleet-prices",
  Settlements: "settlements",
  RedemptionItem: "redemption-item",
  PricingHistory: "pricing-history",
  FuelCode: "fuel-code",
  FuelCodes: "fuel-codes",
  Mops: "mops",
  PricingChanges: "pricing-changes",
  VoucherClaim: "voucher-claim",
  NewCustomerVoucher: "new-customer-voucher",
  PriceBuildup: "price-buildup",
  PriceMovement: "price-movement",
  StationAccount: "station-account",
  CustomerList: "customer-list",
  VoucherCampaign: "voucher-campaign",
  DiscountCampaign: "discount-campaign",
  RfidTopup: "rfid-topup",
  Payment: "payment",
  KYCSubmission: "kyc-submission",
  SupplierWPP: "supplier-wpp",
  LubeservBookings: "lubeserv-bookings",
  StationNegotiatedDiscount: "station-negotiated-discount",
  LubeservOnSite: "lubeserv-on-site",
  LubeservOnWheels: "lubeserv-on-wheels",
};

export { OilcoReports, ReportType };
